import {FeOrder} from "../redux/types";
import {FC} from "react";
import {formatDate} from "../../../date.utils";
import {ServiceChip} from "../../services/components/ServiceChip";
import {Box, Card, CardProps, IconButton, Typography} from "@material-ui/core";
import {MoreVert} from "@material-ui/icons";
import {useHistory} from "react-router-dom";

interface OrderPreviewCardProps {
    order: FeOrder;
    showActions?: boolean
    cardProps?: CardProps;
}

export const OrderPreviewCard: FC<OrderPreviewCardProps> = ({order, cardProps, showActions = true}) => {
    const history = useHistory();
    const navigateToWorkerOrder = () => history.push("/worker/order/" + order.id);
    return (
        <Card variant="outlined" {...cardProps} style={{marginBottom: 4, position: "relative"}} onClick={showActions ? navigateToWorkerOrder : undefined}>
            {showActions &&
                <IconButton
                onClick={navigateToWorkerOrder}
                style={{position: "absolute", right: 0, top: 0}}
            >
                <MoreVert/>
            </IconButton>}
            <Box padding={1.5}>
                <Typography color="secondary">
                    <b>{formatDate(order.estimatedFrom, "EEEE, dd.MM.yyyy")}</b>
                </Typography>
                <Typography variant="body2" style={{display: "flex", marginTop: 4, marginBottom: 4}}>
                    {formatDate(order.from ?? order.estimatedFrom, "HH:mm")} - {formatDate(order.to ?? order.estimatedTo, "HH:mm")}
                </Typography>
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{marginBottom: 4}}
                >
                    {order.serviceAddress.address.formattedAddress}
                </Typography>
                {order.servicesIds.map(sId => <ServiceChip size="small" id={sId}/>)}
            </Box>
        </Card>
    )
}
